import React from "react";
import { Helmet } from "react-helmet";

import BannerComplianceAndGovernance from "components/ComplianceAndGovernance/BannerComplianceAndGovernance";
import ComplianceAndGovernanceAdvice from "components/ComplianceAndGovernance/ComplianceAndGovernanceAdvice";
import SectionExecutive from "components/ComplianceAndGovernance/SectionExecutive";
import SectionCorporativeGovernance from "components/ComplianceAndGovernance/SectionCorporativeGovernance";
import SectionGovernancePrinciple from "components/ComplianceAndGovernance/SectionGovernancePrinciple";
import SectionOrganize from "components/ComplianceAndGovernance/SectionOrganize";
import SectionBoardsAndCommittees from "components/ComplianceAndGovernance/SectionBoardsAndCommittees";
import SectionObjective from "components/ComplianceAndGovernance/SectionObjective";
import SectionDataProtection from "components/ComplianceAndGovernance/SectionDataProtection";
import SectionIntergrityProgram from "components/ComplianceAndGovernance/SectionIntergrityProgram";
import SectionLearnAboutOurProgram from "components/ComplianceAndGovernance/SectionLearnAboutOurProgram";
import SectionPublications from "components/ComplianceAndGovernance/SectionPublications";
import SectionTransparency from "components/ComplianceAndGovernance/SectionTransparency";
import ReportChannel from "components/ReportChannel";
import SectionCertificate from "components/ComplianceAndGovernance/SectionCertificate";

const ComplianceAndGovernance = () => {
  return (
    <>
      <Helmet>
        <title>CNP Seguros Holding Brasil | Conformidade e Governança</title>
        <meta
          name="description"
          content="A CNP Seguros Holding Brasil é a 3a maior seguradora do país e faz parte de um grupo com atuação global, presente em diversos países do mundo."
        />
        <meta
          name="keywords"
          content="CNP Seguros, Holding, seguradora, global, CNP Assurances, CNP Seguros Holding Brasil, CNP no Brasil, parceria"
        />
      </Helmet>

      <BannerComplianceAndGovernance />
      <ComplianceAndGovernanceAdvice />
      <SectionExecutive />
      <SectionDataProtection />
      <SectionIntergrityProgram />
      <SectionLearnAboutOurProgram />
      <SectionPublications />
      <SectionTransparency />
      <ReportChannel background="transparent" hiddenMainDescription />
      <SectionObjective />
      <SectionCorporativeGovernance />
      <SectionGovernancePrinciple />
      <SectionOrganize />
      <SectionBoardsAndCommittees />
      <SectionCertificate />
    </>
  );
};

export default ComplianceAndGovernance;
